// extracted by mini-css-extract-plugin
module.exports = {"statement":"StatementIcon__statement___ISU4H","filled":"StatementIcon__filled___278eA"};